module.exports = __webpack_public_path__ + "img/time.3cca4770.svg";